<template>
  <q-footer class="shop-footer shop-footer--static bg-primary text-white">
    <q-toolbar class="q-px-md">
      <div class="row items-center q-gutter-x-md q-gutter-y-sm full-width">
        <q-btn
          flat
          dense
          no-caps
          class="shop-footer__action text-white"
          label="Оплата"
          @click="showPayment = true"
        />
        <q-btn
          flat
          dense
          no-caps
          class="shop-footer__action text-white"
          label="Поддержка"
          @click="showSupport = true"
        />
        <q-btn
          flat
          dense
          no-caps
          class="shop-footer__action text-white"
          label="Возврат/отмена"
          @click="showReturns = true"
        />
        <q-btn
          flat
          dense
          no-caps
          class="shop-footer__action text-white"
          label="Реквизиты"
          @click="showEnterpriseAddress = true"
        />

        <q-space />

        <a
          class="shop-footer__link text-white"
          :href="confidentialUrl"
          target="_blank"
          rel="noopener"
        >
          Политика ИБ
        </a>
        <a
          class="shop-footer__link text-white"
          :href="confidentialUrl"
          target="_blank"
          rel="noopener"
        >
          Безопасная передача данных
        </a>
      </div>
    </q-toolbar>

    <q-dialog
      v-model="showPayment"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="shop-modal text-white">
        <q-card-section class="row items-center">
          <div class="text-h6">Оплата</div>
          <q-space />
          <q-btn icon="close" round dense flat v-close-popup />
        </q-card-section>

        <q-separator dark />

        <q-card-section>
          <div class="payment-layout">
            <div>
              <div class="text-subtitle2 q-mb-sm">
                Способы оплаты
              </div>

              <div class="payment-grid">
                <div class="payment-tile">
                  <div class="payment-icon payment-icon--mono">
                    <svg
                      role="img"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Visa</title>
                      <path
                        d="M9.112 8.262L5.97 15.758H3.92L2.374 9.775c-.094-.368-.175-.503-.461-.658C1.447 8.864.677 8.627 0 8.479l.046-.217h3.3a.904.904 0 01.894.764l.817 4.338 2.018-5.102zm8.033 5.049c.008-1.979-2.736-2.088-2.717-2.972.006-.269.262-.555.822-.628a3.66 3.66 0 011.913.336l.34-1.59a5.207 5.207 0 00-1.814-.333c-1.917 0-3.266 1.02-3.278 2.479-.012 1.079.963 1.68 1.698 2.04.756.367 1.01.603 1.006.931-.005.504-.602.725-1.16.734-.975.015-1.54-.263-1.992-.473l-.351 1.642c.453.208 1.289.39 2.156.398 2.037 0 3.37-1.006 3.377-2.564m5.061 2.447H24l-1.565-7.496h-1.656a.883.883 0 00-.826.55l-2.909 6.946h2.036l.405-1.12h2.488zm-2.163-2.656l1.02-2.815.588 2.815zm-8.16-4.84l-1.603 7.496H8.34l1.605-7.496z"
                      />
                    </svg>
                  </div>
                  <div class="payment-label">Visa</div>
                </div>

                <div class="payment-tile">
                  <div class="payment-icon payment-icon--mono">
                    <svg
                      role="img"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>MasterCard</title>
                      <path
                        d="M11.343 18.031c.058.049.12.098.181.146-1.177.783-2.59 1.238-4.107 1.238C3.32 19.416 0 16.096 0 12c0-4.095 3.32-7.416 7.416-7.416 1.518 0 2.931.456 4.105 1.238-.06.051-.12.098-.165.15C9.6 7.489 8.595 9.688 8.595 12c0 2.311 1.001 4.51 2.748 6.031zm5.241-13.447c-1.52 0-2.931.456-4.105 1.238.06.051.12.098.165.15C14.4 7.489 15.405 9.688 15.405 12c0 2.31-1.001 4.507-2.748 6.031-.058.049-.12.098-.181.146 1.177.783 2.588 1.238 4.107 1.238C20.68 19.416 24 16.096 24 12c0-4.094-3.32-7.416-7.416-7.416zM12 6.174c-.096.075-.189.15-.28.231C10.156 7.764 9.169 9.765 9.169 12c0 2.236.987 4.236 2.551 5.595.09.08.185.158.28.232.096-.074.189-.152.28-.232 1.563-1.359 2.551-3.359 2.551-5.595 0-2.235-.987-4.236-2.551-5.595-.09-.08-.184-.156-.28-.231z"
                      />
                    </svg>
                  </div>
                  <div class="payment-label">Mastercard</div>
                </div>

                <div class="payment-tile">
                  <div class="payment-icon payment-icon--mono">
                    <svg
                      viewBox="0 0 400 120"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m31 13h33c3 0 12-1 16 13 3 9 7 23 13 44h2c6-22 11-37 13-44 4-14 14-13 18-13h31v96h-32v-57h-2l-17 57h-24l-17-57h-3v57h-31m139-96h32v57h3l21-47c4-9 13-10 13-10h30v96h-32v-57h-2l-21 47c-4 9-14 10-14 10h-30m142-29v29h-30v-50h98c-4 12-18 21-34 21"
                        fill="currentColor"
                      />
                      <path
                        d="m382 53c4-18-8-40-34-40h-68c2 21 20 40 39 40"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div class="payment-label">МИР</div>
                </div>

                <div class="payment-tile">
                  <div class="payment-icon">
                    <svg
                      width="97"
                      height="120"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 97 120"
                    >
                      <path
                        d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z"
                        fill="#5B57A2"
                      />
                      <path
                        d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z"
                        fill="#D90751"
                      />
                      <path
                        d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z"
                        fill="#FAB718"
                      />
                      <path
                        d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z"
                        fill="#ED6F26"
                      />
                      <path
                        d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z"
                        fill="#63B22F"
                      />
                      <path
                        d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z"
                        fill="#1487C9"
                      />
                      <path
                        d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z"
                        fill="#017F36"
                      />
                      <path
                        d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z"
                        fill="#984995"
                      />
                    </svg>
                  </div>
                  <div class="payment-label">СБП</div>
                </div>
              </div>
            </div>

            <div class="payment-side">
              <div class="payment-side__title text-subtitle2 q-mb-sm">
                Банк и T‑Pay
              </div>

              <div class="payment-side__bank">
                <div class="payment-tile payment-tile--wide">
                  <div class="payment-icon payment-icon--wide">
                    <svg
                      width="95"
                      height="34"
                      viewBox="0 0 95 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_732_1259)">
                        <path
                          d="M0 4H29V17.5849C29 21.3238 27.0054 24.7789 23.7676 26.6485L14.5001 32L5.23246 26.6485C1.99457 24.7789 3.32377e-06 21.3238 3.32377e-06 17.5849L0 4Z"
                          fill="#FFDD2D"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8 11V15.5077C8.6164 14.8116 9.73715 14.3406 11.0186 14.3406H12.4111V19.5807C12.4111 20.9748 12.0323 22.3399 11.4703 23.0111H17.5276C16.9668 22.3392 16.5889 20.9758 16.5889 19.5834V14.3406H17.9815C19.2629 14.3406 20.3836 14.8116 21 15.5077V11H8Z"
                          fill="#333333"
                        />
                        <path
                          d="M47.3698 16.7732C48.8816 17.2023 49.5632 18.3866 49.5632 19.5711C49.5632 20.9833 48.7308 22.1676 47.3945 22.6726C46.7396 22.9241 45.9576 23 44.8995 23H36V11H44.7229C45.8313 11 46.6135 11.076 47.2179 11.2772C48.6046 11.7319 49.3107 12.79 49.3107 14.076C49.3107 15.3866 48.4536 16.2939 47.3698 16.7732ZM44.2436 15.7397C44.5967 15.7397 44.8738 15.714 45.0503 15.6391C45.5039 15.4369 45.7061 15.0838 45.7061 14.6805C45.7061 14.2772 45.5039 13.9241 45.0749 13.7732C44.8738 13.6973 44.5967 13.6726 44.2436 13.6726H39.4794V15.7397H44.2436ZM44.3698 20.2269C44.7229 20.2269 45 20.2023 45.2011 20.1262C45.6549 19.9498 45.8571 19.5967 45.8571 19.1687C45.8571 18.7643 45.6549 18.4369 45.2514 18.2861C45.0503 18.2101 44.7732 18.1855 44.3698 18.1855H39.4794V20.2269H44.3698Z"
                          fill="#333333"
                        />
                        <path
                          d="M54.5767 21.2604L53.8962 23H49.761L54.6772 11H60.0214L64.9375 23H60.8281L60.123 21.2604H54.5767ZM55.4839 18.6135H59.2403L57.5007 13.7732H57.2235L55.4839 18.6135Z"
                          fill="#333333"
                        />
                        <path
                          d="M69.3399 11L75.6672 17.58V11H79.1466V23H75.9197L69.4415 16.3699V23H65.9622V11H69.3399Z"
                          fill="#333333"
                        />
                        <path
                          d="M84.9334 18.4626V23H81.2776V11H84.9334V15.5129H85.9413L90.3525 11H94.9413L89.0922 16.7486L95.1681 23H90.3023L85.9413 18.4626H84.9334Z"
                          fill="#333333"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_732_1259">
                          <rect width="95" height="34" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="payment-label">T‑Bank</div>
                </div>

                <div class="payment-tile payment-tile--wide">
                  <div class="payment-icon payment-icon--mono">
                    <svg
                      viewBox="0 0 140 48"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-label="T-Pay"
                    >
                      <rect
                        x="1"
                        y="1"
                        width="138"
                        height="46"
                        rx="23"
                        fill="rgba(0,0,0,0.22)"
                        stroke="rgba(255,255,255,0.18)"
                      />
                      <path
                        d="M16 12h22v18.2c0 2.5-1.3 4.8-3.5 6.1L27 41l-7.5-4.3c-2.2-1.3-3.5-3.6-3.5-6.1V12z"
                        fill="#FFDD2D"
                      />
                      <path
                        d="M22.2 20h9.6v3.1h-3.3v10h-3v-10h-3.3V20z"
                        fill="#333333"
                      />
                      <text
                        x="86"
                        y="31"
                        text-anchor="middle"
                        font-size="18"
                        font-weight="700"
                        fill="rgba(255,255,255,0.92)"
                        font-family="Arial, sans-serif"
                      >
                        PAY
                      </text>
                    </svg>
                  </div>
                  <div class="payment-label">T‑Pay</div>
                </div>
              </div>

              <div class="payment-side__link q-mt-md">
                Сайт банка:
                <a
                  class="text-yellow-4"
                  href="https://tbank.ru"
                  target="_blank"
                  rel="noopener"
                  >tbank.ru</a
                >
              </div>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="q-pa-md">
          <q-btn
            unelevated
            no-caps
            color="accent"
            label="Закрыть"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="showSupport"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="shop-modal text-white">
        <q-card-section class="row items-center">
          <div class="text-h6">Поддержка</div>
          <q-space />
          <q-btn icon="close" round dense flat v-close-popup />
        </q-card-section>
        <q-separator dark />
        <q-card-section>
          <div class="q-mb-md">
            Служба поддержки клиентов:
          </div>
          <div class="q-mb-xs"><strong>Время</strong>: 9:00–17:00 МСК</div>
          <div class="q-mb-xs">
            <strong>Телефон</strong>: +7 (953) 415-22-27
          </div>
          <div class="q-mb-xs">
            <strong>Email</strong>:
            <a class="text-yellow-4" href="mailto:pochtum@mail.ru"
              >pochtum@mail.ru</a
            >
          </div>
        </q-card-section>
        <q-card-actions align="right" class="q-pa-md">
          <q-btn
            unelevated
            no-caps
            color="accent"
            label="Закрыть"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="showReturns"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="shop-modal text-white">
        <q-card-section class="row items-center">
          <div class="text-h6">Возврат и отмена</div>
          <q-space />
          <q-btn icon="close" round dense flat v-close-popup />
        </q-card-section>
        <q-separator dark />
        <q-card-section class="text-body2">
          <p class="q-mb-md">
            Сервис предоставляет доступ к функциональности онлайн‑сервиса на
            условиях, указанных в счёте/договоре и документах, размещённых на
            сайте.
          </p>

          <div class="text-subtitle2 q-mb-xs">
            Отмена заказа / отказ от услуги
          </div>
          <ul class="q-mt-xs q-mb-md">
            <li>
              Запрос на отмену можно направить в поддержку.
            </li>
            <li>
              После начала оказания услуги применяется порядок, установленный
              договором/счётом.
            </li>
          </ul>

          <div class="text-subtitle2 q-mb-xs">Возврат денежных средств</div>
          <ul class="q-mt-xs q-mb-md">
            <li>
              Рассматривается по обращению клиента с указанием данных платежа и
              аккаунта.
            </li>
            <li>
              Сроки и способ возврата зависят от способа оплаты и регламентов
              банка/платёжной системы.
            </li>
          </ul>

          <div class="text-subtitle2 q-mb-xs">Претензии</div>
          <p class="q-mt-xs q-mb-md">
            Если у вас есть претензии по объёму/качеству/срокам оказания услуг —
            направьте обращение в поддержку с описанием ситуации.
          </p>
        </q-card-section>
        <q-card-actions align="right" class="q-pa-md">
          <q-btn
            unelevated
            no-caps
            color="accent"
            label="Закрыть"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="showEnterpriseAddress"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="shop-modal text-white">
        <q-card-section class="row items-center">
          <div class="text-h6">Реквизиты</div>
          <q-space />
          <q-btn icon="close" round dense flat v-close-popup />
        </q-card-section>
        <q-separator dark />
        <q-card-section class="text-body2">
          <div class="q-mb-xs">
            <strong>Исполнитель:</strong> ИП Кузнецова Кристина Петровна
          </div>
          <div class="q-mb-xs"><strong>ОГРНИП:</strong> 319527500038143</div>
          <div class="q-mb-xs"><strong>ИНН:</strong> 521404743803</div>
          <div class="q-mb-xs">
            <strong>Адрес регистрации:</strong> Нижегородская область,
            Володарский район, город Володарск, ул. Лядова, дом 70
          </div>
          <div class="q-mb-xs">
            <strong>Дата регистрации:</strong> 29 марта 2019 г.
          </div>
          <div class="q-mt-md">
            <a
              class="text-yellow-4"
              :href="confidentialUrl"
              target="_blank"
              rel="noopener"
              >Политика конфиденциальности</a
            >
          </div>
        </q-card-section>
        <q-card-actions align="right" class="q-pa-md">
          <q-btn
            unelevated
            no-caps
            color="accent"
            label="Закрыть"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-footer>
</template>

<script>
export default {
  name: "ShopFooter",
  data() {
    return {
      showPayment: false,
      showSupport: false,
      showReturns: false,
      showEnterpriseAddress: false,
      confidentialUrl: "https://почтум.рф/support/legal/confidential/"
    };
  }
};
</script>

<style lang="sass" scoped>
.shop-footer
  border-top: 1px solid rgba(255, 255, 255, 0.08)

.shop-footer--static
  position: static !important

.shop-footer__action
  opacity: 0.4
  font-size: 12px

.shop-footer__action:hover
  opacity: 1

.shop-footer__link
  text-decoration: none
  opacity: 0.4
  font-size: 12px
  white-space: nowrap

.shop-footer__link:hover
  opacity: 1
  text-decoration: underline

.shop-modal
  width: 860px
  max-width: 95vw
  background: #50597b
  border: 1px solid rgba(255, 255, 255, 0.12)
  border-radius: 12px

.pay-logo
  width: 120px
  height: 48px

.pay-logo svg
  display: block
  width: 100%
  height: 100%

.payment-layout
  display: grid
  grid-template-columns: 1fr 320px
  gap: 16px

@media (max-width: 800px)
  .payment-layout
    grid-template-columns: 1fr

.payment-grid
  display: grid
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr))
  gap: 12px

.payment-tile
  background: rgba(255, 255, 255, 0.08)
  border: 1px solid rgba(255, 255, 255, 0.16)
  border-radius: 12px
  padding: 12px
  display: grid
  grid-template-columns: 56px 1fr
  align-items: center
  gap: 10px

.payment-tile--wide
  grid-template-columns: 72px 1fr

.payment-icon
  width: 56px
  height: 40px
  display: flex
  align-items: center
  justify-content: center

.payment-icon--wide
  width: 72px
  height: 40px

.payment-icon svg
  width: 100%
  height: 100%

.payment-icon--mono
  color: rgba(255, 255, 255, 0.92)

.payment-icon--mono svg
  fill: currentColor

.payment-label
  font-size: 12px
  opacity: 0.9

.payment-side
  background: rgba(0, 0, 0, 0.06)
  border: 1px solid rgba(255, 255, 255, 0.10)
  border-radius: 12px
  padding: 12px

.payment-side__bank
  display: grid
  gap: 12px

.tpay-pill
  width: 100%
  height: 40px
  border-radius: 999px
  background: rgba(0, 0, 0, 0.22)
  border: 1px solid rgba(255, 255, 255, 0.18)
  display: flex
  align-items: center
  justify-content: center
  font-weight: 700
</style>
